import {
    CRITERIA_FIELDS_BY_CLASSIFICATION,
    type SectionProps,
} from './constants'
import { Field, Textarea } from './controls'

// 평가 기준·내용 — 분류에 따라 의미 있는 안내문(기준·관리·현장·세부항목·지도관
// 고려사항·기타)만 표시한다(편집 가능).
export function GuidanceSection({ form, set, isDirty }: SectionProps) {
    return (
        <section className='border-border space-y-4 rounded-[var(--radius)] border p-4'>
            <div>
                <h3 className='text-foreground text-sm font-bold'>
                    평가 기준·내용
                </h3>
                <p className='text-muted-foreground mt-1 text-xs'>
                    {form.classification === 'HACCP관리'
                        ? 'HACCP관리: 세부항목·지도관 고려사항·기타를 표시해요.'
                        : '선행요건: 기준·관리·현장·지도관 고려사항·기타를 표시해요.'}
                </p>
            </div>
            {CRITERIA_FIELDS_BY_CLASSIFICATION(form.classification).map((f) => (
                <Field key={f.key} label={f.label} dirty={isDirty(f.key)}>
                    {(control) => (
                        <Textarea
                            {...control}
                            rows={4}
                            value={form[f.key] ?? ''}
                            dirty={isDirty(f.key)}
                            onChange={(v) => set(f.key, v)}
                        />
                    )}
                </Field>
            ))}
        </section>
    )
}
